import { ReactNode } from "react";

import { FormattedMessage } from "react-intl";

import { Text } from "@atlaskit/primitives-next";

import { CustomerDomainOrg } from "@/components/fastshift/src/state/types";

import { DROPDOWN_ORG_ID } from "../../../../../state";
import { messages } from "../messages";

export const OrgSelectorItemMessage = ({
    org
}: {
    org: CustomerDomainOrg;
}): ReactNode => {
    switch (org.orgId) {
        case DROPDOWN_ORG_ID.NO_ORG:
            return (
                <Text>
                    <FormattedMessage
                        {...messages.orgSelectorDropdownNoOrgForOrgAdmin}
                    />
                </Text>
            );
        case DROPDOWN_ORG_ID.OTHER_ORGS:
            return (
                <Text>
                    <FormattedMessage
                        {...messages.orgSelectorDropdownOtherOrgsForOrgAdmin}
                    />
                </Text>
            );
        default:
            return <Text>{org.orgName}</Text>;
    }
};
